import { render } from "./NotFound.vue?vue&type=template&id=0ab64606"
const script = {}
script.render = render

export default script